<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="scoutisme-extension">
    <div class="row col-12">
      <div class="col-6 mySlides">
        <div class="right">
          <p>
            Bonjour ! Vous êtes sur notre sous-camp, on fait partie de la branche Extension. On est à peu près 300, ça
            tourne bien !
          </p>
          <div class="arrowright"></div>
        </div>

        <div class="right">
          <p>
            Comment, vous ne savez pas ce que c’est, l’extension ? Oh c’est tout simple, c’est du scoutisme normal, sauf
            que nous on a des besoins particuliers, donc on s’organise un peu différemment. Par exemple Élie est
            aveugle, et avec Yvon là-bas on est malentendant. Raoul et José un peu plus loin, eux d’habitude ils sont à
            l’hôpital, à cause d’une maladie, et ils font partie de la même patrouille, ils s’envoient un carnet avec
            des activités à faire.
          </p>
          <div class="arrowright"></div>
        </div>
      </div>
      <div class="col-6 mySlides">
        <div class="right">
          <p>Sinon, qu’est-ce qui vous amène ?</p>
          <div class="arrowright"></div>
        </div>
        <div class="right">
          <p>
            Une liste d’objets, faites voir ? Ah dites, on peut vous passer de la corde, on en a plein ! On est assez
            forts en nœuds dans ma patrouille. D’ailleurs, est-ce que vous savez quel nœud symbolise ce Jamboree ? Il
            est pas très facile à faire celui-là en plus ! Allez, je vous l’épelle, pour vous aider.
          </p>
          <div class="arrowright"></div>
        </div>
        <div class="right">
          <p>
            <img
              src="https://cdn.exploreve.fr/content/cluedo/carrick.png"
              class="img-fluid ${3|rounded-top,rounded-right,rounded-bottom,rounded-left,rounded-circle,|}"
              alt="lsf"
            />
          </p>
          <div class="arrowright"></div>
        </div>
        <div>
          <div class="left col-12">
            <div class="arrowleft"></div>
            <p class="row">
              <input type="text" class="form-control col-6 offset-1" id="noeud" placeholder="Entre ta réponse" />
              <button class="btn btn-secondary col-4 mx-2" v-on:click="verify()">Valider</button>
            </p>
          </div>
        </div>
        <div class="right" id="badresponse">
          <p class="text-danger h5">Mauvaise réponse ! Réessaye</p>
          <div class="arrowright"></div>
        </div>
      </div>
      <div class="col-6" id="FoundSlide">
        <div class="right">
          <p>Bravo ! Voilà une corde pour le ballon !</p>
          <div class="arrowright"></div>
        </div>
        <img src="https://cdn.exploreve.fr/content/cluedo/corde.svg" class="img-fluid mt-5" alt="corde" />
        <button @click="getCorde()" class="btn btn-secondary btn-lg mx-auto col" type="button" data-dismiss="modal">
          Récupérer la corde
        </button>
      </div>

      <div class="col-6">
        <img
          src="https://cdn.exploreve.fr/content/cluedo/Extension.svg"
          alt="patrouille d'extension"
          class="img-fluid my-5"
        />
      </div>
    </div>
    <div style="text-align: center;" v-if="!found">
      <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
      <span class="dot" v-on:click="currentSlide(1)"></span>
      <span class="dot" v-on:click="currentSlide(2)"></span>
      <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "ScoutismeExtension",
  data: function () {
    return {
      found: false,
      slideIndex: 1
    };
  },
  mounted: function () {
    this.currentSlide(1);
  },
  methods: {
    verify() {
      this.slideIndex = 3;
      var slides = document.getElementsByClassName("mySlides");
      if (document.getElementById("noeud").value.toUpperCase() == "carrick".toUpperCase()) {
        this.found = true;
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        document.getElementById("FoundSlide").style.display = "block";
      } else {
        document.getElementById("badresponse").style.display = "flex";
      }
    },
    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },
    currentSlide(n) {
      if (this.slideIndex < n) return;
      this.slideIndex = n;
      this.showSlides();
    },
    showSlides() {
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (this.slideIndex > slides.length) {
        this.slideIndex = 1;
      }
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (let i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    },
    getCorde() {
      this.$emit("recupObject", "corde");
      this.$emit("closeModal");
    }
  }
};
</script>

<style scoped lang="scss">
.btn {
  font-family: "Faune";
}

.left,
.right {
  font-family: "Faune";
  display: table;
  background-color: white;
  max-width: 500px;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
}

.left {
  margin-right: auto;
}

.right {
  margin-left: auto;
}

.arrowleft {
  position: relative;
  content: "";
  left: -20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid white;
  z-index: 5;
}

.arrowright {
  position: relative;
  content: "";
  left: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-left: 20px solid white;
}
#FoundSlide,
#badresponse {
  display: none;
}
</style>
